import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/HeaderPort.css';

const DEFAULT_PLACEHOLDER = "https://placehold.co/1920x450/222/999?text=Puerto+Sin+Imagen";

export default function HeaderPort({ title, subtitle, imageUrl, webUrl }) {
  const navigate = useNavigate();
  
  // Estado local para la imagen de fondo final
  const [bgImage, setBgImage] = useState(DEFAULT_PLACEHOLDER);

  useEffect(() => {
    // Si no hay URL, usamos el placeholder directamente
    if (!imageUrl || imageUrl.trim() === "") {
      setBgImage(DEFAULT_PLACEHOLDER);
      return;
    }

    // Intentamos cargar la imagen para ver si es válida
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      // Si carga bien, la usamos
      setBgImage(imageUrl);
    };

    img.onerror = () => {
      // Si falla, nos quedamos con el placeholder
      console.warn(`No se pudo cargar la imagen para ${title}. Usando placeholder.`);
      setBgImage(DEFAULT_PLACEHOLDER);
    };

  }, [imageUrl, title]); // Se re-ejecuta si cambia la prop imageUrl

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <header 
      className="header-port" 
      style={{ 
        backgroundImage: `linear-gradient(to top, rgba(0,0,0,0.8) 10%, rgba(0,0,0,0) 70%), url('${bgImage}')` 
      }}
    >
      <div className="header-port-content">
        <h1>
          {webUrl ? (
            <a 
              href={webUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none', cursor: 'pointer' }}
              className="header-title-link"
            >
              {title} <i className="fas fa-external-link-alt" style={{ fontSize: '0.5em', verticalAlign: 'middle', marginLeft: '8px', opacity: 0.7 }}></i>
            </a>
          ) : (
            title
          )}
        </h1>
        <p>{subtitle}</p>
      </div>
      
      <button 
        className="header-port-close" 
        onClick={handleClose} 
        aria-label="Cerrar"
      >
        <i className="fas fa-times"></i>
      </button>
    </header>
  );
}